import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "../errorPopup/errorPopup.module.css";
import mediaDevicesErrorPopupStyles from "../mediaDevicesErrorPopup/mediaDevicesErrorPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";

function MediaDevicesNotFoundErrorPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup}>
      <h2
        className={`${popupStyles.popup__title} ${mediaDevicesErrorPopupStyles.popup__title}`}
      >
        {t("MEDIA_DEVICES_NOT_FOUND_ERROR_TITLE")}
      </h2>
      <img
        src={doctor}
        alt={t("IMAGE_ALT_VENCHY_DOCTOR")}
        className={`${popupStyles.popup__img} ${mediaDevicesErrorPopupStyles.popup__img}`}
      />
      <p className={mediaDevicesErrorPopupStyles.popup__text}>
        {t("MEDIA_DEVICES_NOT_FOUND_ERROR_TEXT")}
      </p>
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >
        {t("MEDIA_DEVICES_NOT_FOUND_ERROR_CONFIRM_BUTTON")}
      </button>
    </article>
  );
}

export default MediaDevicesNotFoundErrorPopup;
